export const ROUTING = {
  LANDING: 'home',
  DASHBOARD: 'dashboard',
  LOGIN: 'login',
  SIGNUP: 'signup',
  CONFIRM_EMAIL: 'confirm-email',
  ROOT: '/',
  ONBOARDING: 'setup',
  FORGOT_PASSWORD: 'forgot-password',
  CHECK_EMAIL: 'check-email',
  RESET_PASSWORD: 'reset-password',
  LEADS_DATABASE: 'database',
  LEAD_SCRAPERS: 'lead-scrapers',
  EMAIL_CAMPAIGNS: 'email-campaigns',
  EMAIL_ACCOUNTS: 'email-accounts',
  SETTINGS: 'settings',
  VISUAL_SCRAPER: 'visual-scraper',
  CAMPAIGN_DETAILS: 'campaign-details',
  EDIT_SCRAPER: 'edit-scraper',
  PRICING: 'pricing',
  CHECKOUT_SUCCESS: 'checkout/success',
  CHECKOUT_CANCELLED: 'checkout/cancelled',
  MAILBOX: 'mailbox',
  ALL_CAMPAIGNS: 'all-campaigns',
  QUICK_CAMPAIGN: 'quick-campaign',
  IMPORT_CAMPAIGN: 'import-campaign',
  EMAIL_TEMPLATES: 'email-templates',
  EMAIL_TEMPLATE_BUILDER: 'email-template-builder',
  EMAIL_ANALYTICS: 'email-analytics',
  EMAIL_WARMUP: 'email-warmup',
  WARMUP_ONBOARDING: 'warmup-setup',
  LEAD_PIPELINE: 'lead-pipeline',
  CUSTOM_DOMAINS: 'custom-domains',
  EMAIL_INFRASTRUCTURE: 'custom-domains/infrastructure',
  PROVISIONING_PROGRESS: 'custom-domains/:id/provisioning',
  TERMS_OF_SERVICE: 'terms-of-service',
  PRIVACY_POLICY: 'privacy-policy',
  // Admin routes
  ADMIN_WARMUP_POOL: 'admin/warmup-pool',
  ADMIN_ENGAGEMENT_DASHBOARD: 'admin/engagement-dashboard',
  ADMIN_DNS_MANAGEMENT: 'admin/dns-management',
};
